<template>
  <div class="comp-container">
    <div class="nav-list">
      <div
        class="nav-item"
        :class="activeTab == navItem.key ? 'active' : ''"
        @click="switchNav(navItem)"
        v-for="(navItem, index) in navList"
        :key="index"
      >
        <AutoTitle textAlign="center">{{ navItem.name }}</AutoTitle>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AutoTitle from "@/components/autoTitle";

export default {
  name: "eSportPageNav",
  props: {
    navList: {},
    activeTab: {},
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    switchNav(item) {
      this.$emit("update:activeTab", item.key);
      this.$emit("changeTab", item.key);
    },
  },
  components: {
    AutoTitle,
  },
  mounted() {},
  created() {},
};
</script>

  <style lang="scss" scoped>
@import "./index.scss";
.comp-container {
  $nav-title-height: $page-nav-height;
  // $nav-title-height: 0.57rem;
  // width: 100%;
  height: $nav-title-height;
  .nav-list {
    vertical-align: top;
    height: $nav-title-height;
    background-color: rgba(0, 0, 0, 0.2);
    display: inline-flex;
    flex-shrink: 0;
    .nav-item {
      $padding-bottom: 0.06rem;
      width: 2.06rem;
      text-align: center;
      height: $nav-title-height;
      line-height: $nav-title-height - $padding-bottom;
      font-size: 0.26rem;
      color: #fff;
      text-shadow: 0 -0.01rem 0.06rem rgba(0, 0, 0, 0.38);

      &.active {
        $active-color: #ffbb1c;
        border-bottom: $padding-bottom solid $active-color;
        background-image: -webkit-linear-gradient(
          bottom,
          rgba(255, 187, 28, 0.3),
          rgba(255, 187, 28, 0)
        );
        position: relative;
        &::after {
          content: "";
          box-sizing: border-box;
          $size: $padding-bottom;
          // position: absolute;
          margin: -$padding-bottom/1.5 auto 0;
          display: block;
          width: $size;
          height: $size;
          border: #{$size} solid rgba(0, 0, 0, 0);
          border-top: 0;
          border-bottom-color: $active-color;
        }
      }
    }
  }
}
:export {
  bgColor: #000;
}
</style>
